import React, { useState } from "react"
import { defPath, fetchPath } from '../config/defPath'
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { useSession } from '../hooks/useState'
import { Controls } from "../components/layout/menu_help"
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
    Navigation, Pagination
  } from 'swiper';
SwiperCore.use([Navigation, Pagination]);
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function App(){
    const { validateSession } = useSession(state => state)

    const dataChallenges = async () => {
        const res = await fetch(`${fetchPath}/aguila/loyalty/weekly/challenges`)
        const dataRes = await res.json()

        
        const challenges = dataRes.challenges    
        let dataC: any = []
        const fut = document.querySelector('#futbolin'),
        predi = document.querySelector('#prediccion'),
        tada = document.querySelector('#tada'),
        tapa = document.querySelector('#tapa');

        const futText = fut?.querySelector(".boxChallenges__single--title")
        if (futText) {
            futText.textContent = dataRes.data.futbolin.copy
        }
        const tadaText = tada?.querySelector(".boxChallenges__single--title")
        if (tadaText) {
            tadaText.textContent = dataRes.data.tada.copy
        }
        const tapaText = tapa?.querySelector(".boxChallenges__single--title")
        if (tapaText) {
            tapaText.textContent = dataRes.data.tapa.copy
        }
        const prediccionText = predi?.querySelector(".boxChallenges__single--title")
        if (prediccionText) {
            prediccionText.textContent = dataRes.data.predicciones.copy
        }

        const pointsText = document.querySelector(".weeklyChallenge__content--points")
        if (pointsText) {
            pointsText.textContent = dataRes["redeemed-text"]
        }
        const redeemedText = document.querySelector(".weeklyChallenge__content--redeemed")
        if (redeemedText) {
            redeemedText.textContent = dataRes.redeemed
        }
        const titleText = document.querySelector(".weeklyChallenge__content--title")
        if (titleText) {
            titleText.textContent = dataRes.title
        }
        const subtText = document.querySelector(".weeklyChallenge__content--subtitle")
        if (subtText) {
            subtText.textContent = dataRes.description
        }
        
        if(challenges.futbolin == 'off'){
            fut?.classList.add('hidden')
        }else if(challenges.futbolin == true){
            fut?.classList.add('check')
            dataC.push(challenges.futbolin)
        }

        if(challenges.prediccion == 'off'){
            predi?.classList.add('hidden')
        }else if(challenges.prediccion == true){
            predi?.classList.add('check')
            dataC.push(challenges.prediccion)
        }

        if(challenges.tada == 'off'){
            tada?.classList.add('hidden')
        }else if(challenges.tada == true){
            tada?.classList.add('check') 
            dataC.push(challenges.tada)            
        }

        if(challenges.tapa == 'off'){
            tapa?.classList.add('hidden')
        }else if(challenges.tapa == true){
            tapa?.classList.add('check')
            dataC.push(challenges.tapa)
        }

        if(dataC.length >= dataRes.total){
            document.querySelector('.weeklyChallenge__content--subtitle')?.classList.add('hidden')
            document.querySelector('.weeklyChallenge__content--redeemed')?.classList.add('redemeed')
            document.querySelector('.weeklyChallenge__content--points')?.classList.add('redemeed')
            document.querySelector('.weeklyChallenge__content--time')?.classList.add('redemeed')
        }

        const DATE_TARGET: any = new Date(dataRes.date);
        const SPAN_DAYS: any = document.querySelector('span#days');
        const SPAN_HOURS: any = document.querySelector('span#hours');
        const MILLISECONDS_OF_A_SECOND = 1000;
        const MILLISECONDS_OF_A_MINUTE = MILLISECONDS_OF_A_SECOND * 60;
        const MILLISECONDS_OF_A_HOUR = MILLISECONDS_OF_A_MINUTE * 60;
        const MILLISECONDS_OF_A_DAY = MILLISECONDS_OF_A_HOUR * 24

        function updateCountdown() {
            const NOW:any = new Date()
            const DURATION: any = DATE_TARGET - NOW;
            const REMAINING_DAYS: any = Math.floor(DURATION / MILLISECONDS_OF_A_DAY);
            const REMAINING_HOURS: any = Math.floor((DURATION % MILLISECONDS_OF_A_DAY) / MILLISECONDS_OF_A_HOUR);
            if(SPAN_DAYS) SPAN_DAYS.innerHTML = REMAINING_DAYS;
            if(SPAN_HOURS) SPAN_HOURS.innerHTML = REMAINING_HOURS;
        }

        if(dataRes.init) {
            // const initDay = new Date("2023-06-24 00:00:00"); // 
            const initDay = new Date(dataRes.init.day); // "2023-06-01 00:00:00"
            const currentDate = new Date(); // "2023-06-23 11:00:00"
            
            if (initDay > currentDate) {
                const timeStatus = document?.querySelector(".weeklyChallenge__content--time")
                timeStatus && timeStatus.classList.add("hidden")
                const points = document?.querySelector(".weeklyChallenge__content--points")
                points && points.classList.add("hidden")
                const subtitle = document?.querySelector(".weeklyChallenge__content--subtitle")
                if (subtitle) subtitle.innerHTML = dataRes.init.description.value.replace(/(<([^>]+)>)/ig, "").replace(/[\n\r]/g, "")
                const container = document?.querySelector(".weeklyChallenge__content")
                container && container.classList.add("no-date")
            }
        }
        
        updateCountdown();
        setInterval(updateCountdown, MILLISECONDS_OF_A_HOUR);

    }
        
    React.useEffect(() => {
        validateSession()
        dataChallenges()
    }, [])


    const handleClick = (e:any, ar:string) => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label':  ar + ' - Challenges',
            'interaction':'true',
            'component_name': 'Modo_Carrera_Challenges',
            'element_text': e.target.innerText,
        });          
    }

    return (
        <>
            {/* Page HTML */}

            <section className="weeklyChallenge">
                <NewHeader />
                <Modal />
                <Controls isStadium= {false} />
                <div className="weeklyChallenge__content">                    
                    <picture className="">
                        <source className="" media="(max-width: 767px)" srcSet={`${defPath}/assets/images/retoSemanal/bkretoMob.jpeg`}/>
                        <img className="weeklyChallenge__content--bk" src={`${defPath}/assets/images/retoSemanal/bkReto.jpeg`} alt="" />
                    </picture>
                    <h1 className="weeklyChallenge__content--title">¡Semana de emociones!</h1>
                    <div className="weeklyChallenge__content--subtitle">Supera los retos de esta semana y gana</div>
                    <div className="weeklyChallenge__content--redeemed">Felicitaciones crack, recibiste</div>
                    <p className="weeklyChallenge__content--points">0 puntos</p>
                    <div className="boxChallenges">
                        <div className="boxChallenges__single" id="futbolin">
                            <img className="boxChallenges__single--icon" src={`${defPath}/assets/images/retoSemanal/icon1.png`} alt="" />
                            <p className="boxChallenges__single--title">JUEGA EN EL FUTBOLÍN</p>
                            <a className="boxChallenges__single--btn" onClick={(e) => handleClick(e, 'Futbolin')} href="/estadio-aguila/instrucciones">Jugar ahora</a>
                        </div>
                        <div className="boxChallenges__single" id="tada">
                            <img className="boxChallenges__single--icon" src={`${defPath}/assets/images/retoSemanal/icon2.png`} alt="" />
                            <p className="boxChallenges__single--title">Ingresa dos códigos tada</p>
                            <a className="boxChallenges__single--btn" onClick={(e) => handleClick(e, 'Redenciones Tada')} href="/estadio-aguila/codigo-tada">Ingresar</a>
                        </div>
                        <div className="boxChallenges__single" id="tapa">
                            <img className="boxChallenges__single--icon" src={`${defPath}/assets/images/retoSemanal/icon3.png`} alt="" />
                            <p className="boxChallenges__single--title">Escanea una tapa</p>
                            {/* <a className="boxChallenges__single--btn" onClick={(e) => handleClick(e, 'Retos diarios')} href="/estadio-aguila/escanea-tapa">Ver Info</a> */}
                        </div>
                        <div className="boxChallenges__single" id="prediccion">
                            <img className="boxChallenges__single--icon" src={`${defPath}/assets/images/retoSemanal/icon4.png`} alt="" />
                            <p className="boxChallenges__single--title">Predice un resultado</p>
                            <a className="boxChallenges__single--btn" onClick={(e) => handleClick(e, 'Predicciones')} href="/estadio-aguila/predicciones">ir a predicciones</a>
                        </div>
                    </div>
                    <div className="weeklyChallenge__content--time">
                        <img src={`${defPath}/assets/images/retoSemanal/iconWatch.png`} alt="" />
                        <div className="boxCopy">
                            <p className="time"><span id="days"></span> Días <span id="hours"></span> Horas</p>
                            <p className="copy">FIN DEL CORTE SEMANAL</p>
                        </div>
                    </div>
                </div>
            </section>  
        </>
    )
}
export default App